import { $authHost } from "./index";

export const getTracks = async () => {
    const { data } = await $authHost.get("/api/track");

    return data;
};


export const findTracks = async ({title, track}) => {
    const { data } = await $authHost.get("/api/track/bystr?song=" + track + "&title=" + title);

    return data;
};

export const getTrack = async (id) => {
    const { data } = await $authHost.get(`/api/track/${id}`);

    return data;
};

export const updateTrack = async (id, body) => {
    const { data } = await $authHost.put(`/api/track/${id}`, body);

    return data;
};

export const createTrack = async (body) => {
    const { data } = await $authHost.post("/api/track", body);

    return data;
};
export const deleteTrack = async (id) => {
    const { data } = await $authHost.delete(`/api/track/${id}`);

    return data;
};

